import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Badge, Link, ListItemText, Tooltip, useTheme } from '@mui/material';

//
import { NavItemProps } from '../types';

import { StyledItem } from './styles';

// ----------------------------------------------------------------------

export default function NavItem({
  item,
  depth,
  open,
  active,
  isExternalLink,
  ...other
}: NavItemProps) {
  const theme = useTheme();

  const { title, path, children, disabled, caption, roles, quarter } = item;

  const subItem = depth !== 1;

  const badgeColor =
    quarter === 2 ? 'error' : quarter === 3 ? 'warning' : quarter === 4 ? 'info' : 'secondary';

  const renderContent = (
    <StyledItem depth={depth} active={active} disabled={disabled} caption={!!caption} {...other}>
      <Badge badgeContent={quarter} color={badgeColor} sx={{ '& .MuiBadge-badge': { right: -14 } }}>
        <ListItemText
          primary={title}
          secondary={
            caption && (
              <Tooltip title={caption} placement="top-start">
                <span>{caption}</span>
              </Tooltip>
            )
          }
          primaryTypographyProps={{
            noWrap: true,
            component: 'span',
            fontSize: !subItem ? '12px' : '16px',
            color: !subItem
              ? theme.palette.grey[500]
              : active
              ? theme.palette.common.white
              : theme.palette.text.light,
            fontWeight: !subItem || active ? 600 : 400,
          }}
        />
      </Badge>
    </StyledItem>
  );

  const renderItem = () => {
    // ExternalLink
    if (isExternalLink)
      return (
        <Link href={path} target="_blank" rel="noopener" underline="none">
          {renderContent}
        </Link>
      );
    if (children.length > 0) {
      return <div>{renderContent}</div>;
    }
    // Default
    return (
      <Link component={RouterLink} to={path} underline="none">
        {renderContent}
      </Link>
    );
  };

  return <>{renderItem()}</>;
}
